import { getInfo } from '@/api'
//
export default {
	namespaced: true,
	//
	state: {
		messages: [

		]
	},
	//
	mutations: {
		addMessage (state, message) {
			state.messages.push(message)
		}
	},
	//
	actions: {
		SOCKET_newMessage (store, data) {
			console.log(data)
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/chat.js